import React from 'react';
import { CHALLENGE_TYPES } from '../../common/constants';
import {
    numberWithCommas,
    unixTimestampToHumanReadable,
} from '../../common/utils';
import ButtonToNavigate from '../../common/ButtonToNavigate';

export const transformPartnerChallenges = (challenges) => {
    if (challenges && challenges.length) {
        return challenges.map(transformChallenge);
    } else {
        return [];
    }
};

function getBadgeTitle(challenge) {
    if (challenge.isGlobal) return CHALLENGE_TYPES.GLOBAL;
    else if (challenge.connected || challenge.parentChallenge)
        return CHALLENGE_TYPES.CONNECTED;
    else return CHALLENGE_TYPES.LOCAL;
}

export function transformConnectedChallenges(challenges) {
    // if challenge is not null and not empty object
    if (challenges && challenges.length) {
        return challenges.map((challenge) => transformChallenge(challenge));
    }
    return [];
}

export function transformChallenge(challenge) {
    // if challenge is not null and not empty object
    if (
        challenge &&
        Object.keys(challenge).length !== 0 &&
        challenge.constructor === Object
    ) {
        let transformedChallenge = {
            id: challenge.id,
            name: (
                <ButtonToNavigate
                    path={`/campaigns/${challenge.id}`}
                    buttonText={<h2>{challenge.name}</h2>}
                    challenge={challenge}
                />
            ),
            title: challenge.name,
            description: challenge.mission,
            thumbnail: challenge.profilePicture
                ? challenge.profilePicture
                : null,
            banner: challenge.banner ? challenge.banner : null,
            startDate: unixTimestampToHumanReadable(challenge.startDate),
            endDate: unixTimestampToHumanReadable(challenge.expiresAt),
            pickups: challenge.litterCount
                ? numberWithCommas(challenge.litterCount)
                : '0',
            target: challenge.litterQuantityTarget
                ? numberWithCommas(challenge.litterQuantityTarget)
                : '0',
            progress: Math.round(
                (challenge.litterCount / challenge.litterQuantityTarget) * 100,
            ),
            createDate: unixTimestampToHumanReadable(challenge.createdAt),
            createdBy:
                challenge.creator && challenge.creator.name
                    ? challenge.creator.name
                    : challenge.creator && challenge.creator.fullName
                    ? challenge.creator.fullName
                    : '',
            creatorThumbnail: challenge.creator
                ? challenge.creator.profilePicture
                : '',
        };
        return transformedChallenge;
    } else {
        return {
            id: '',
            name: '',
            title: '',
            description: '',
            isGlobal: false,
            isConnected: false,
            thumbnail: '',
            startDate: '',
            endDate: '',
            pickups: '0',
            target: '0',
            progress: 0,
            isActive: false,
            badge: getBadgeTitle(challenge),
            createDate: '',
            createdBy: '',
            creatorThumbnail: '',
        };
    }
}
